import { useQuery } from '@apollo/client'
import { Tabs } from 'antd'
import { D4_Complementprocedure, D4_Demande } from '../../types'
import { COMPLEMENT_PROCEDURE_QUERY } from '../../apollo/query/complementProcedure'
import { lazy, Suspense } from 'react'
import Spinner from '../Spinner'
const Factures = lazy(() => import('../Procedure/Factures'))
const Assignation = lazy(() => import('../Procedure/Assignation'))
const Chronologie = lazy(() => import('../Procedure/Chronologie'))
const Delibere = lazy(() => import('../Procedure/Delibere'))
const Procedure = lazy(() => import('../Procedure/Procedure'))

const DemandeProcedure = ({ demandeId }: { demandeId: number }) => {
  const { data } = useQuery<{ procedure: D4_Demande }>(COMPLEMENT_PROCEDURE_QUERY, { variables: { demandeId } })

  if (!data) return null

  const complementprocedure = data.procedure.complementprocedure as D4_Complementprocedure
  if (!complementprocedure) return <div>pas de procédure</div>

  return (
    <Tabs defaultActiveKey="procédure">
      <Tabs.TabPane tab="Procédure" key="procédure">
        <Suspense fallback={<Spinner />}>
          <Procedure complementProcedure={complementprocedure} titre={data.procedure?.description ?? ''} />
        </Suspense>
      </Tabs.TabPane>
      <Tabs.TabPane tab="Assignation" key="assignation">
        <Suspense fallback={<Spinner />}>
          <Assignation complementProcedure={complementprocedure} />
        </Suspense>
      </Tabs.TabPane>
      <Tabs.TabPane tab="Chronologie" key="chronologie">
        <Suspense fallback={<Spinner />}>
          <Chronologie complementProcedure={complementprocedure} />
        </Suspense>
      </Tabs.TabPane>
      <Tabs.TabPane tab="Délibéré" key="délibéré">
        <Suspense fallback={<Spinner />}>
          <Delibere complementProcedure={complementprocedure} />
        </Suspense>
      </Tabs.TabPane>
      <Tabs.TabPane tab="Factures" key="factures">
        <Suspense fallback={<Spinner />}>
          <Factures complementProcedure={complementprocedure} />
        </Suspense>
      </Tabs.TabPane>
    </Tabs>
  )
}

export default DemandeProcedure
